import React from 'react';
// import Header from "../../components/shared/Header";
import Header from '../../components/landing02/header';
// import Footer from '../../components/shared/Footer';
import Footer from '../../components/landing02/footer';
import BookADemoForm from '../../components/BookADemo/BookADemoForm';

const BookADemo = () => {
  return (
    <>
      <Header />
      <BookADemoForm />
      <Footer />
    </>
  );
};

export default BookADemo;
